import { makeStyles } from 'tss-react/mui';

const useSsoLoginChoiceStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(4),
    width: '100%',
    maxWidth: 308,
    boxSizing: 'border-box',
    padding: theme.spacing(3),
  },
  actions: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    width: '100%',
  },
}));

export default useSsoLoginChoiceStyles;
